import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { IssueService } from '../../issues/issue.service';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import {  SortedColumn, GridMainFilter, GridSelection, SelectionMode } from '../../core/shared/grid/grid.model';
import { GridParamsRestorable } from '../../core/services/grid-params-restoring/grid-params-restoring.model';
import { IssuesExtRest } from '../issues-ext.rest';
import { Permissions } from '../../core/services/permissions/permissions.model';
import { IssueRow } from '../../issues/issues.model';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { ShellRestService } from '../../shell/shell.rest';

@Component({
  selector: 'app-issues-ext-list',
  templateUrl: './issues-ext-list.component.html',
  styleUrls: []
})
export class IssuesExtListComponent extends GridSelection implements OnInit,AfterViewInit, GridParamsRestorable {

  //grid Params
  initialFilters: any;
  initialPageNumber: number;
  initialPageSize: number;
  initialSortedColumn: SortedColumn;
  editedItemId: any;
  previousMainFilters: any;
  detailsPath: string;

  path: string;
  @ViewChild(GridComponent) grid: GridComponent;

  public permissions: Permissions;
  public isRestoredMainFilter: boolean;
  private isEditable: boolean;
  private isRemovable: boolean;
  private isAdd: boolean;
  private issueState: string;
  private canAdd; 

  private headers = [
    { displayName: 'Tytuł', propertyName: 'fullTitle', propertyType: 'string'},
    { displayName: 'Zmieniono', propertyName: 'updatedDate', propertyType: 'date', isInitSort: true, dateFormat: 'dd.MM.yyyy HH:mm'},
    { displayName: 'Zgłoszono', propertyName: 'createdDate', propertyType: 'date' , dateFormat: 'dd.MM.yyyy HH:mm'},
    { displayName: 'Kontrahent', propertyName: 'customerCode', propertyType: 'string' },
    { displayName: 'Etap', propertyName: 'projectFullName', propertyType: 'string' },
    { displayName: 'Zgłaszający', propertyName: 'reporterName', propertyType: 'string' },
    { displayName: 'Przypisany', propertyName: 'elementAssignee', propertyType: 'string' },
    { displayName: 'Odpowiedzialny', propertyName: 'assigneeName', propertyType: 'string' },
    { displayName: 'Autor', propertyName: 'author', propertyType: 'string' },
    { displayName: 'Status', propertyName: 'issueState', propertyType: 'string' }    
  ];

  private gridMenuButtons: MenuButton[] = [
    { text: 'Kopiuj', class: "btn-success", icon: '', onClick: () => { this.copy() }, enabled: true, isForSelected: true }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private issueRest: IssuesExtRest,
    private gridParamsRestoringService: GridParamsRestoringService,
    private spinnerService: SpinnerService,
    private issueService: IssueService,
    private permissionService: PermissionsService, 
    private shellRest: ShellRestService) {
      super();
      this._grid = this.grid; 
    }

  ngOnInit() {
    this.spinnerService.show();

    this.setPermissions('IssueExt');
    this.selectionMode = this.selectionMode === SelectionMode.none ? SelectionMode.multi : this.selectionMode;
    
    this.route.data.subscribe( x => {
      this.issueState = x.issueState;
      this.path = `api/issueexternal/grid/${this.issueState}`;
      this.detailsPath = `/extissues/${this.issueState}/issuedetails`;
      if(this.issueState.includes('finished')){
        this.canAdd = false
      }      
    });
    this.tryRestoreFiltersAndPage();
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
    this.isEditable = this.permissions.canEdit || this.permissions.canShow;
    this.canAdd = this.permissions.customerId && this.permissions.customerId != 0 && this.permissions.canAdd;
  }

  private tryRestoreFiltersAndPage() {
    var previousGridParams = this.gridParamsRestoringService.getPreviousGridParams(this.detailsPath);
    if (!previousGridParams) {
      return;
    }
    this.initialFilters = previousGridParams.initialFilters;
    this.previousMainFilters = previousGridParams.previousMainFilters;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
  }

  private onRowAdd() {
    this.shellRest.IsBlockedCustomer().subscribe((isBlockedCustomer: boolean) => {
      if (isBlockedCustomer)
        sweetAlert("Kontrahent jest zablokowany. Brak możliwości kopiowania zgłoszeń.");
      else {
        this.issueService.complete();
        this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
        this.router.navigate(['issuedetails', 'new'], {queryParams: {id: 0} , relativeTo: this.route } );
      }
    });
  }

  private onRowEdit(row: IssueRow) {
    this.issueService.complete();
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id);
    this.router.navigate(['issuedetails', row.id], { queryParams: { id: row.id }, relativeTo: this.route });
  }

  private onRowDelete(row: IssueRow) {
    this.shellRest.IsBlockedCustomer().subscribe((isBlockedCustomer: boolean) => {
      if (isBlockedCustomer)
        sweetAlert("Kontrahent jest zablokowany. Brak możliwości kopiowania zgłoszeń.");
      else{
          sweetAlert('Czy na pewno chcesz usunąć zgłoszenie?', {
            buttons: {
              yes: {
                text: 'Tak',
                value: 'yes'
            },
              no: {
                text: 'Nie',
                value: 'no',
              }
            }
          })
          .then((value) => {
            switch (value) {
              case 'yes':
                this.issueRest.checkIfIssueHasElements(row.id).subscribe((result: boolean) => {
                if (result === true) {
                  let message = `Zgłoszenie posiada elementy. Czy na pewno chcesz je usunąć?`;
                  sweetAlert(message,{
                    buttons: {
                      yes: {
                        text: 'Tak',
                        value: 'yes'
                    },
                      no: {
                        text: 'Nie',
                        value: 'no',
                      }
                    }
                  })
                  .then((value) => {
                    switch (value) {
                      case 'yes':
                        this.deleteIssue(row.id);
                        break;
                      }
                  });
                } else {
                  this.deleteIssue(row.id);
                }
              });
            break;
            }
          });
      }
    });
  }
  
  private deleteIssue(id: number) {    
      this.issueRest.removeIssue(id).subscribe((result: string) => {
        if (result) {
          sweetAlert({ text: `Usunięto zgłoszenie` });
          this.grid.refreshData(false);
        }
      });     
  }

  private copy() {
    var selectedItems = this.grid.getSelectedItems();

    if (selectedItems.length == 0) {
      sweetAlert("Nie zaznaczono elementu.");
      return;
    }

    if (selectedItems.length > 1) {
      sweetAlert("Zaznaczono więcej niż jeden element.");
      return;
    }

    this.shellRest.IsBlockedCustomer().subscribe((isBlockedCustomer: boolean) => {
      if (isBlockedCustomer)
        sweetAlert("Kontrahent jest zablokowany. Brak możliwości kopiowania zgłoszeń.");
      else {
        this.gridParamsRestoringService.saveCurrentGridParams(this.grid,  selectedItems[0].id);
        this.router.navigate(['issuedetails', 'copy', selectedItems[0].id], { queryParams: { isCopy: 1, id: selectedItems[0].id}, relativeTo: this.route });
      }
    });  
  }
}
